import { createSelector } from '@ngrx/store'

export const getSecuritySettingsState = createSelector(
  (state: any) => state.securitySettings,
  (state: any) => state,
)
